export enum DrawStage {
  draft = "Draft",
  drawRequested = "Draw Requested",
  inProgress = "In Progress",
  hold = "Hold",
  decline = "Decline",
  initialApproval = "Initial Approval",
  finalApproval = "Final Approval",
  drawSubmitted = "Draw Submitted",
  wireTransferInitiated = "Wire Transfer Initiated",
  wireCompleted = "Wire Completed",
  WireUnsuccessful = "Wire Unsuccessful",
  DrawInQueue = "Draw In Queue"
}
